import React, {useState} from 'react';
import moment from 'moment';

import useUser from '../../hooks/useUser';
import { useGetProvidersQuery } from '../../redux/services/providerApi';
import { useGetSessionsQuery } from '../../redux/services/sessionApi';
import { useGetVacationTimesQuery } from '../../redux/services/vacationTimeApi';
import {
  useGetProviderAvailabilitiesQuery
} from '../../redux/services/providerAvailabilityApi';

import AppDashboard from '../AppDashboard';
import AdminSchedulingScreen from '../../components/admin/AdminSchedulingScreen';

const getStartAndEndDate = ({date, calendarView}) => {
  if (calendarView === 'week') {
    return {
      startDate: moment(date).startOf('week').toISOString(),
      endDate: moment(date).endOf('week').toISOString(),
    };
  }
  return {
    startDate: moment(date).startOf('day').toISOString(),
    endDate: moment(date).endOf('day').toISOString(),
  };
};

const AdminSchedulingPage = () => {
  const [date, setDate] = useState(new Date());
  const [calendarView, setCalendarView] = useState('day');
  const [providerIds, setProviderIds] = useState([]);
  const user = useUser();
  const {startDate, endDate} = getStartAndEndDate({date, calendarView});
  const providersQuery = useGetProvidersQuery(
    {ids: providerIds}, 
    {skip: !providerIds.length}
  );
  const sessionsQuery = useGetSessionsQuery({
    provider_ids: providerIds,
    start_time: startDate,
    end_time: endDate,
    limit: 100,
    include_nonowned_sessions: true,
  }, {skip: !providerIds.length});
  const awayTimesQuery = useGetVacationTimesQuery({
      provider_ids: providerIds,
      start_time: startDate,
    }, {skip: !providerIds.length});
  const availabilitiesQuery = useGetProviderAvailabilitiesQuery(
    {provider_ids: providerIds},
    {skip: !providerIds.length}
  );
  const childProps = {
    date,
    loading: !user,
    providers: providersQuery?.data || providersQuery?.data?.data || [],
    sessions: sessionsQuery?.data?.data || [],
    awayTimes: awayTimesQuery?.data?.data || awayTimesQuery?.data || [],
    availabilities: availabilitiesQuery?.data?.data || [],
    onChangeProviderIds: (e, val) => setProviderIds(val),
    onDateChange: (e, dt) => setDate(dt),
  };
  console.log('providerQuery', providerIds, providersQuery);
  return (
    <AppDashboard 
      title='Admin Scheduling'
      loading={childProps.loading} 
      error={childProps.error} 
    >
      <AdminSchedulingScreen {...childProps} />
    </AppDashboard>
  );
};

export default AdminSchedulingPage;